// extracted by mini-css-extract-plugin
export default {"navbar":"header_navbar__sfeIl","navItem":"header_navItem__EYYsN"};